import { SVGProps } from 'react';

const SvgRouble = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					d='M5.362 16.276l.5-1A.5.5 0 016.309 15h9.882a.5.5 0 01.447.724l-.5 1a.5.5 0 01-.447.276H5.809a.5.5 0 01-.447-.724z'
					fill='currentColor'
					opacity={0.3}
				/>
				<path
					d='M8 3.716h5.107c.935 0 1.779.084 2.53.253.751.169 1.395.445 1.932.828.537.383.95.874 1.242 1.472.291.598.437 1.319.437 2.162 0 .905-.169 1.664-.506 2.277a4.106 4.106 0 01-1.369 1.483c-.575.376-1.245.648-2.012.817-.767.169-1.58.253-2.438.253h-2.231V20H8V3.716zm4.716 7.107c.475 0 .928-.034 1.357-.104a3.75 3.75 0 001.15-.367c.337-.177.606-.418.805-.725.2-.307.299-.705.299-1.196 0-.475-.1-.862-.299-1.161a2.067 2.067 0 00-.793-.702 3.398 3.398 0 00-1.127-.333c-.422-.054-.855-.081-1.3-.081h-2.116v4.669h2.024z'
					fill='currentColor'
				/>
			</g>
		</svg>
	);
};

export default SvgRouble;
